import { PageHeader } from "@/components/common/Chrome";
import { Inquiries } from "@/components/common/Inquiries";

export default function InquiriesPage() {
  return (
    <div className="space-y-6" data-testid="inquiries-page">
      <PageHeader
        eyebrow="Governance · Inquiries"
        title="Ask the person behind an audit entry to explain it"
        description="A query starts as a request for information and, if it needs to, becomes a review, a formal inquiry or disciplinary action. Only the Board Secretary moves it along, closes it, parks it or rejects it — and the remark column always says where it stands."
      />
      <Inquiries />
    </div>
  );
}
